<template lang='pug' src='./reviews.pug'></template>

<script>
import Loader from 'components/loader/loader'
import BlockTitle from 'components/block/block-title/block-title'
import CustomReviewsContent from 'components/custom/custom-reviews-content/custom-reviews-content'
import { Carousel, Slide } from 'vue-carousel'
import Arrow from 'templates/smaller-arrow.icon.html'
import Icon from 'components/icon/icon'

export default {
  name: 'reviews',
  computed: {
    props () {
      return this.$store.state.pages['reviews']
    },
    loading () {
      return this.$store.state.loading
    }
  },
  created () {
    this.$store.dispatch('VIEW_NAV', true)
  },
  data () {
    return {
      active: false,
      arrowNext: `<div class='pages-reviews__arrow pages-reviews__arrow--next'>${Arrow}</div>`,
      arrowPrev: `<div class='pages-reviews__arrow pages-reviews__arrow--prev'>${Arrow}</div>`
    }
  },
  components: {
    Loader,
    BlockTitle,
    CustomReviewsContent,
    Carousel,
    Slide,
    Icon
  }
}
</script>



// WEBPACK FOOTER //
// reviews.vue?7def90e6